<template>
    <div>
        <footer>
            <div class="container mb-32">
                <div class="row">
                    <div class="col-5 col-md-7 col-lg-8 col-xl-2 order-1 mb-4 mb-xl-0">
                        <router-link to="/" class="logo">
                            <img :src="logoSvg" alt="" class="d-none d-lg-inline-block">
                            <img :src="logoSvg" alt="" class="d-inline-block d-lg-none">
                        </router-link>
                    </div>
                    <div class="col-6 col-sm-5 col-md-3 col-lg-4 col-xl-2 order-3 order-xl-2 mb-4 mb-xl-0">
                        <div class="title-4 mb-20">Компания</div>
                        <div><router-link class="h5" to="/contact">Контакты</router-link></div>
                        <div><router-link class="h5" to="/delivery">Доставка и оплата</router-link></div>
                        <div><router-link class="h5" to="/rules">Правила проката</router-link></div>
                        <div><router-link class="h5" to="/promotions">Акции</router-link></div>
                        <div><router-link class="h5" to="/news">Новости</router-link></div>
                        <div><router-link class="h5" to="/services">Услуги</router-link></div>
                        <div><router-link class="h5" to="/projects">Проекты</router-link></div>
<!--                        <div><router-link class="h5" to="/rules/publichnaya-oferta">Публичная оферта</router-link></div>-->
                        <div><router-link class="h5" to="/about">О компании</router-link></div>
                        <div><router-link class="h5" to="/sitemap">Карта сайта</router-link></div>

                    </div>

                    <div class="col-6 col-sm-5 col-md-4 col-xl-3 order-4 order-xl-3 mb-4 mb-xl-0">
                        <div class="title-4 mb-20">Каталог</div>
                        <div v-for="(item, i) in navigation_bottom" :key="i">
                            <router-link class="h5" :to="item.url">
                                {{ item.name }}
                            </router-link>
                        </div>
                    </div>

                    <div class="text-center text-md-left col-md-5 col-lg-4 col-xl-3 order-5 order-xl-4">
                        <div class="title-4 mb-20">Контактная информация</div>
                        <div>
                            <a href="tel:+79774097239" class="h5"
                               v-bind:class="{ 'eye-black': !flagEye }">
                                +7 977 409 72 39
                            </a>
                            <img class="eye-image-black" v-bind:class="{ 'eye-image-black-hide': flagEye }"
                                 @click="flagEye = !flagEye" src="/img/icons/eye-black.svg" alt="">
                        </div>
                        <div>
                            <a id="email" href="mailto:order@mrental.ru" class="mb-20 h5">
                                order@mrental.ru
                            </a>
                        </div>
                        <div v-if="settings.contacts_address">
                            <div class="title-4 mb-20">Мы находимся по адресу:</div>
                            <div class="h5 mb-24" v-html="settings.contacts_address"></div>
                        </div>
                        <div v-if="settings.contacts_time">
                            <div class="title-4 mb-20">Режим работы:</div>
                            <div class="h5 mb-24" v-html="settings.contacts_time"></div>
                        </div>

                        <div class="ya-taxi-widget" data-ref="mrental.ru"
                             data-proxy-url="https://{app}.redirect.appmetrica.yandex.com/route?start-lat={start-lat}&amp;start-lon={start-lon}&amp;end-lat={end-lat}&amp;end-lon={end-lon}&amp;tariffClass={tariff}&amp;ref={ref}&amp;appmetrica_tracking_id={redirect}&amp;lang={lang}&amp;erid={erid}"
                             data-tariff="econom" data-app="3" data-lang="ru" data-redirect="1178268795219780156"
                             data-description=" г. Москва, ул. Угрешская улица, 2Бс1" data-size="s" data-theme="normal"
                             data-title="Добраться на Яндекс такси" data-use-location="true" data-point-a=""
                             data-point-b="37.694001,55.712056">
                        </div>
                    </div>

                    <div
                        v-if="settings.instagram || settings.vk || settings.facebook || settings.youtube || settings.tiktok"
                        class="col-7 col-md-5 col-lg-4 col-xl-2 order-2 order-xl-5">
                        <div class="title-4 mb-20 d-none d-xl-block">Мы в соцсетях</div>
                        <div class="social mb-24">
                            <a v-if="settings.instagram" rel="noopener" target="_blank"
                               :href="plainText(settings.instagram)" class="ico-social">
                                <img src="/svg/instagram.svg" alt="">
                            </a>
                            <a v-if="settings.vk" rel="noopener" target="_blank"
                               :href="plainText(settings.vk)" class="ico-social">
                                <img src="/svg/vk.svg" alt="">
                            </a>
                            <a v-if="settings.facebook" rel="noopener" target="_blank"
                               :href="plainText(settings.facebook)" class="ico-social">
                                <img src="/svg/facebook.svg" alt="">
                            </a>
                            <a v-if="settings.youtube" rel="noopener" target="_blank"
                               :href="plainText(settings.youtube)" class="ico-social">
                                <img src="/svg/youtube.svg" alt="">
                            </a>
                            <a v-if="settings.tiktok" rel="noopener" target="_blank"
                               :href="plainText(settings.tiktok)" class="ico-social">
                                <img src="/svg/tik-tok.svg" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="d-flex flex-column flex-xl-row align-items-center justify-content-between bottom-part">
                    <div class="h5 mb-3 mb-xl-0">
                        &copy; 2020-{{ new Date().getFullYear() }} MRental. Все права защищены.
                        ООО МРентал ИНН 6732201394.
                    </div>
                    <div class="img-social">
                        <img src="/svg/payment.svg" alt="">
                    </div>
                </div>
            </div>

        </footer>
    </div>
</template>

<script>
export default {
    inject: ['settings'],

    data() {
        return {
            flagEye: false,
            logoSvg: require('./../../svg/logo-new-dark-2.svg'),
        }
    },

    computed: {
        navigation_bottom() {
            return this.$store.getters.getTopCategories;
        },
    },

    methods: {
        plainText(text) {
            return text.replace(/<\/?[^>]+(>|$)/g, "");
        },
    },
}
</script>
